import React from "react";
import ModalCancelButton from "../ModalMessages/ModalCancelButton";
import ModalConfirmButton from "../ModalMessages/ModalConfirmButton";

const LogoutModal = ({onConfirmFn, onCloseFn}) => {
    return (
        <div className='modal-buttons-container'>

            <ModalCancelButton 
                custompadding="10px 35px"
                onClickFn={onCloseFn}
                label='No'
                customWidth={200}
                customisedFontSize={"16px"}
            />

            <ModalConfirmButton
                custompadding="10px 35px"
                customBgColor={"#376AFA"}
                label='Yes'
                onClickFn={onConfirmFn}
                customWidth={200}
                customisedFontSize={"16px"}
            />
        </div>
    )
};

export default LogoutModal

